import { Link, useLocation } from 'react-router-dom'

import PersonIcon from '@/assets/icons/person.svg?react'
import TeamIcon from '@/assets/icons/team.svg?react'
import { Trans } from '@/components'
import { cn } from '@/utils/style'

export function MemberViewSwitcher() {
  const location = useLocation()
  // Check if on Team View (shared page)
  const isTeamView = location.pathname.includes('/team/data/shared')

  return (
    <div className="bg-neutral-50 p-1 rounded-xl flex gap-1">
      <Link
        to="/team/data/member"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          !isTeamView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <PersonIcon className="w-5 h-5" />
        <span>
          <Trans i18nKey="common.viewSwitcher.personalView">Personal View</Trans>
        </span>
      </Link>
      <Link
        to="/team/data/shared"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          isTeamView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <TeamIcon className="w-5 h-5" />
        <span>
          <Trans i18nKey="common.viewSwitcher.teamView">Team View</Trans>
        </span>
      </Link>
    </div>
  )
}
